import { get, compact } from "lodash"
import { percentageFormatter } from "helpers/formatters/numbers"

export const TOTAL_RISK = "total"
export const FACTORS_RISK = "factors"
export const SPECIFIC_RISK = "specific"

export const METRICS = {
  [TOTAL_RISK]: {
    label: "Total",
    path: "total",
    formatter: percentageFormatter,
  },
  [FACTORS_RISK]: {
    label: "Factors",
    path: "attribution.summary.factors",
    formatter: percentageFormatter,
  },
  [SPECIFIC_RISK]: {
    label: "Specific",
    path: "attribution.summary.specific",
    formatter: percentageFormatter,
  },
}

const QUERY = `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
  model(id: $modelId) {
    simulation(positionSet: $positionSet,base: $base,from: $from,to: $to,interval: AUTO) {
      risk {
        date
        total
        attribution {
          summary {
            factors
            specific
          }
          factors {
            id
            category
            name
            value
          }
        }
      }
    }
  }
}`

export function createRiskMultiDateQuery(modelId, positionSet, base, from, to) {
  return {
    key: compact(["risk", "multiDate", modelId, positionSet, base, from, to]),
    query: QUERY,
    variables: {
      modelId,
      positionSet,
      base,
      from,
      to,
    },
    select: (graphqlResult) => {
      const risk = get(graphqlResult, "data.model.simulation.risk", [])
      return ({
        values: {
          formatter: percentageFormatter,
          // The code to map the dates data deliberately does not use lodash functions to improve the performance
          dates: risk.map(({ date, ...dateData }) => {
            const metrics = Object.entries(METRICS).reduce((acc, [metricId, metric]) => {
              acc[metricId] = get(dateData, metric.path)
              return acc
            }, {})

            const factors = dateData.attribution.factors.reduce((acc, { id, category, value }) => {
              acc[id] = value
              acc[category] = (acc[category] ?? 0) + value
              return acc
            }, {})

            return {
              date,
              ...metrics,
              ...factors,
            }
          }),
        },
      })
    },
  }
}
